module.exports = __webpack_public_path__ + "static/media/ball_1_7.130e40ed.mp3";